import { HeadFC, PageProps } from "gatsby";
import * as React from "react";

import { formatPageTitle } from "helpers/meta";

import { HeadingText, Section } from "../styles/shared";
import Layout from "../templates/layout";
import { analytics } from "helpers/meta";

const NotFoundPage: React.FC<PageProps> = () => {
  return (
    <Layout>
      <Section>
        <HeadingText $variant="heading01">Not found</HeadingText>
      </Section>
    </Layout>
  );
};

export default NotFoundPage;

export const Head: HeadFC = () => (
  <>
    {analytics()}
    <title>{formatPageTitle("Not Found")}</title>;
  </>
)
